export enum StatusCode {
  Unauthorized = 401,
}
